import {HTTP_REST_URLS} from "../config/urls";
import { useApiMiddleware } from "./useApiMiddleware";

export const useProfile = (headers) => new Promise((res, rej) => {

    const url = HTTP_REST_URLS.GET_PROFILE;

    fetch(url, {
        method: 'GET',
        headers: headers
    })
        .then((res) => (res.json()))
        .then(async(response) => {
            
            const resultValue = await useApiMiddleware(response)
            
            // const resultValue = response;

            if(!resultValue.error)
            {
                const data = resultValue.data;

                if(typeof data === 'object')
                {
                    res(data)
                }
                else
                {
                    res(null)
                }
            }
            else
            {
                res(null)
            }

        })

})
